<!--
긴급입고 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>긴급입고 설정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small" >
                <app-input-ex
                    class="uk-margin-bottom"
                    type="text"

                    v-model="inputs.tracking_no"
                    label="트래킹번호"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder=""
                > </app-input-ex>

                <app-input-ex
                    class="uk-margin-bottom"
                    type="textarea"
                    :textarea-rows="3"

                    v-model="inputs.reason"
                    label="사유"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder=""
                > </app-input-ex>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    완료
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역ID
             */
            regionId: Number,
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    tracking_no: null,
                    reason: null,
                },
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {

                // 폼띄우기
                this.displayForm();
            },


            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/urgent-ship-ins',
                    data: _.merge({
                        '_token': this.csrfToken,
                        'region_id': this.regionId,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>